<template>
  <div>
    <BigGameRank />
  </div>
</template>
<script>
import BigGameRank from './modal/BigGameRank'
export default {
  name: 'MatchLoopRank',
  components: {
    BigGameRank
  },
  created () {
  },
  destroyed () {},
  mounted () {
    // 初始化
  },
  data () {
    return {
      matchId: this.$route.query.matchId,
      programId: Number(this.$route.query.programId)
    }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/comm/components/MatchLoopRank.vue